function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.874 38.886c9.93 0 17.98-7.984 17.98-17.832s-8.05-17.831-17.98-17.831-17.98 7.983-17.98 17.831c0 9.848 8.05 17.832 17.98 17.832z",
  fill: "#CFD7DE"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.873 33.449c-4.28 0-7.997-3.424-7.997-7.731 0-2.637 1.232-4.76 3.568-5.983-1.329-1.284-2.141-2.599-2.141-4.5a6.495 6.495 0 0 1 .4-2.608c.31-.834.79-1.596 1.407-2.24a6.598 6.598 0 0 1 2.184-1.506 6.645 6.645 0 0 1 5.211.008 6.597 6.597 0 0 1 2.18 1.512 6.534 6.534 0 0 1 1.4 2.243c.308.835.442 1.722.393 2.61 0 1.93-.842 3.215-2.172 4.5 2.337 1.222 3.569 3.342 3.569 5.982.007 4.29-3.722 7.713-8.002 7.713zm0-11.381c-.73 0-1.445.214-2.053.617a3.672 3.672 0 0 0-1.36 1.645 3.637 3.637 0 0 0 .8 3.994 3.723 3.723 0 0 0 4.027.794 3.689 3.689 0 0 0 1.66-1.35 3.643 3.643 0 0 0 .622-2.035 3.634 3.634 0 0 0-1.076-2.603 3.693 3.693 0 0 0-2.62-1.077v.014zm0-9.325a2.595 2.595 0 0 0-1.436.421c-.427.279-.76.676-.959 1.142a2.539 2.539 0 0 0 .54 2.793 2.6 2.6 0 0 0 2.808.573c.474-.191.879-.517 1.165-.936.286-.42.44-.913.443-1.42a2.524 2.524 0 0 0-.733-1.825 2.564 2.564 0 0 0-1.828-.763v.015z",
  fill: "#fff"
});

var SvgWorkspaceDefaultLogo = function SvgWorkspaceDefaultLogo(props) {
  return React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/workspace-default-logo.89193f71.svg";
export { SvgWorkspaceDefaultLogo as ReactComponent };